import { useEffect, useState } from 'react';
import { useAnalysisQueue } from '@/hooks/useAnalysisQueue';
import { Badge } from '@/components/ui/badge';
import { Loader2, CheckCircle } from 'lucide-react';

export function QueueStatusIndicator() {
  const { getPendingJobs } = useAnalysisQueue();
  const [pendingCount, setPendingCount] = useState(0);

  useEffect(() => {
    const checkPending = async () => {
      const jobs = await getPendingJobs();
      setPendingCount(jobs.length);
    };

    checkPending();
    const interval = setInterval(checkPending, 3000); // Check every 3 seconds

    return () => clearInterval(interval);
  }, [getPendingJobs]);

  if (pendingCount === 0) {
    return (
      <Badge variant="outline" className="gap-1.5">
        <CheckCircle className="w-3 h-3" />
        <span className="text-xs">Queue Clear</span>
      </Badge>
    );
  }

  return (
    <Badge variant="secondary" className="gap-1.5 animate-pulse">
      <Loader2 className="w-3 h-3 animate-spin" />
      <span className="text-xs">{pendingCount} Processing</span>
    </Badge>
  );
}
